/**
 * A conversa abre na mensagem mais recente e FICA lá enquanto o resto carrega
 * (pedido do Igor, 2026-11-03) — o mesmo no ERP e no Cut (`grudarNoFim.ts`).
 * Antes rolava ao fim uma vez só: as fotos, os cartões e os emojis terminavam
 * de carregar depois, cresciam o conteúdo e a tela ficava várias mensagens
 * acima. Enquanto a pessoa está no fim, cada crescimento a mantém no fim;
 * rolou para cima, para de grudar.
 */
import { useEffect, useRef } from "react";

export const PERTO_DO_FIM_PX = 120;

/**
 * `seletor`: os itens que mudam de altura (as mensagens e os dias).
 * `chave`: a conversa — trocar de conversa volta a grudar.
 * `quantas`: o número de mensagens, para observar as novas.
 * Devolve a ref de "grudado", para soltar ao pular para uma mensagem.
 */
export function useGrudarNoFim(fluxoRef, seletor, chave, quantas) {
  const grudadoRef = useRef(true);
  useEffect(() => {
    grudadoRef.current = true;
  }, [chave]);
  useEffect(() => {
    const el = fluxoRef.current;
    if (!el) return undefined;
    const aoRolar = () => {
      grudadoRef.current = el.scrollHeight - el.scrollTop - el.clientHeight < PERTO_DO_FIM_PX;
    };
    el.addEventListener("scroll", aoRolar, { passive: true });
    let observador = null;
    if (typeof ResizeObserver !== "undefined") {
      observador = new ResizeObserver(() => {
        if (grudadoRef.current) el.scrollTop = el.scrollHeight;
      });
      el.querySelectorAll(seletor).forEach((item) => observador.observe(item));
    }
    return () => {
      el.removeEventListener("scroll", aoRolar);
      if (observador) observador.disconnect();
    };
  }, [fluxoRef, seletor, chave, quantas]);
  return grudadoRef;
}
